import React, { Component } from "react";
import Banner from "./banner";
import MiddleBanner from "./middlebanner";
import About from "./about";
import { apiCalling } from "../apiService";
import Testimonial from "./testimonial";
import Gallery from "./gallery";
import { Helmet } from "react-helmet";
import Calender from "../healthTrackerCalender/health-trackers"

export default class home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: [],
      centreData: [],
      aboutData: [],
      bouquetData:[],
      specialitiesData:[],
    };
  }

    componentDidMount(){

        this.getLoadHomePage();
        this.getSectionDetails();
    }

getSectionDetails(){

  const bannerData = JSON.parse(window.sessionStorage.getItem("Banner")); 
  const About = JSON.parse(window.sessionStorage.getItem("About"));
  const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
  const Bouquet = JSON.parse(window.sessionStorage.getItem("Bouquet"));
  const speciality = JSON.parse(window.sessionStorage.getItem("Specialities"));

  if(bannerData) {
    this.setState({ bannerData: bannerData[0].sectionList});
  } 
  if(speciality) {
    this.setState({ specialitiesData: speciality[0].sectionList});
  } 
  if(About) {
    this.setState({ aboutData: About[0].sectionList});
  } 
  if (Centre) { 
    this.setState({ centreData: Centre[0].sectionList});
  } 
  if(Bouquet) {
    this.setState({ bouquetData: Bouquet[0].sectionList});
  } 
  
}

    getLoadHomePage() {
             
          const jsonReq = {
            method: "POST",
            body: JSON.stringify({
              functionName: "getSiteDetails",
              siteId: window.sessionStorage.getItem("siteId"),
              siteUrl: "",
            }),
          };
         
          apiCalling(jsonReq).then((data) => {
            if (data.success === "1") {   
              const hosDataVar = JSON.stringify(
                data.siteDetailsData[0].hospitalData
              );
              window.sessionStorage.setItem(
                "siteServices",
                JSON.stringify(data.siteDetailsData[0].services)
              );
             
              if (hosDataVar) {
                window.sessionStorage.setItem(
                  "footerhospitalData",
                  JSON.stringify(data.siteDetailsData[0].hospitalData)
                );
                window.sessionStorage.setItem(
                  "footerHospitalName",
                  data.siteDetailsData[0].hospitalData.hospitalName
                );
                window.sessionStorage.setItem(
                  "footerHospitalcity",
                  data.siteDetailsData[0].hospitalData.city
                );
                window.sessionStorage.setItem(
                  "footerHospitaladdress",
                  data.siteDetailsData[0].hospitalData.address
                );
                window.sessionStorage.setItem(
                  "footerHospitalstateName",
                  data.siteDetailsData[0].hospitalData.stateName
                );
                window.sessionStorage.setItem(
                  "footerHospitalzipCode",
                  data.siteDetailsData[0].hospitalData.zipCode
                );
              }
              let themeSectionLength=0;
              if(typeof data.siteDetailsData[0].themeSectionList!='undefined'){
                themeSectionLength=data.siteDetailsData[0].themeSectionList.length
              }
              
              for (
                let i = 0;
                i < themeSectionLength;
                i++
              ) {
                window.sessionStorage.setItem(
                  data.siteDetailsData[0].themeSectionList[i].themeSectionName,
                  JSON.stringify(
                    data.siteDetailsData[0].themeSectionList[i].themeSectionContent
                  )
                );
              }
              window.sessionStorage.setItem(
                "doctorDetails",
                JSON.stringify(data.siteDetailsData[0].doctorDetails)
              );
            }
          });
     
      }
    render() {
         
        return (
          <div class="mentalHealthWrap">
        <Helmet>
          <title>{window.sessionStorage.getItem("seo_title")}</title>
          <meta name="description" content={window.sessionStorage.getItem("seo_description")} />
          <meta name="keywords" content={window.sessionStorage.getItem("seo_keywords")} ></meta>
          <meta name="twitter:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="twitter:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="twitter:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta name="facebook:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="facebook:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="facebook:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta property="og:title" content={window.sessionStorage.getItem("seo_title")} ></meta>
          <meta property="og:image" content={window.sessionStorage.getItem("siteLogo")} ></meta>
          <meta property="og:description" content={window.sessionStorage.getItem("seo_description")} ></meta>
          <meta property="og:url" content={window.sessionStorage.getItem("slug")} ></meta>

        </Helmet>
            <div className="pamba-wrapper">
             {this.state.bannerData.length > 0 ?
                <Banner />
                : ''}
               {this.state.aboutData.length > 0 ?
                <About />
                : ''}
                {this.state.centreData.length > 0 ?
                <Testimonial />
                : ''}
                {this.state.specialitiesData.length > 0 ?
                <div class="container-fluid">
                  <MiddleBanner></MiddleBanner> 
                </div>
                : ''}
                 {this.state.bouquetData.length > 0 ?
                <Gallery />
                : ''}
                {window.sessionStorage.getItem("hasHealthTracker")==='true' && (  
                <Calender />
                  )}   
            </div>
            </div>
        );
    }
}